import { ReactNode } from 'react';
import { ThemeContext, Theme } from './themeContext';

export function ThemeProvider({ children }: { children: ReactNode }) {
  // Always light mode - Temasek brand
  const theme: Theme = 'light';
  const toggleTheme = () => {}; // No-op

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
